<template>
  <div>
    <b-overlay :show="show_overlay" rounded="sm">
      <b-form @submit="onSubmit" class="row">
        <b-card class="mt-2">
          <template #header>
            <b-row class="text-end">
              <b-col class="text-start fs-6">
                <b-badge variant="success" class="mr-2 fs-6">
                  Campanhas /
                  {{ campanha.nome }} -
                  {{
                    this.$store.getters['pedidoInfo'].situacao === 'P' ||
                    this.$store.getters['pedidoInfo'].situacao === 'A'
                      ? 'Alteração '
                      : 'Cadastro '
                  }}
                  {{ labelHeader }}
                </b-badge>
                <b-badge class="bg-info text-white fs-6">{{
                  this.$store.getters['pedidoInfo'].situacao === 'P'
                    ? 'Pedido'
                    : 'Aberto'
                }}</b-badge>
              </b-col>
              <b-col>
                <input
                  type="file"
                  id="sheet"
                  accept=".xls, .xlsx"
                  @change="importarPedido"
                  hidden
                />
                <label
                  for="sheet"
                  class="btn btn-primary my-1"
                  title="Importar Pedido"
                >
                  <BootstrapIcon icon="file-earmark-arrow-up" color="white" />
                </label>
                <b-button
                  v-show="this.$store.getters['pedidoInfo'].cam_cond_pgto_id"
                  class="ml-2"
                  title="Exportar Pedido"
                  @click="exportarPedido"
                  variant="info"
                >
                  <BootstrapIcon icon="file-earmark-arrow-down" color="white" />
                </b-button>
                <b-button
                  class="ml-2"
                  variant="warning"
                  title="Exportar Produtos da Campanha"
                  @click="this.downloadProdutosCampanha"
                >
                  <BootstrapIcon icon="file-earmark-arrow-down" color="white" />
                </b-button>
                <b-button
                  v-show="pedidoValido && subPedidosValidos"
                  class="ml-2"
                  variant="success"
                  @click="this.confirmaPedido"
                >
                  Confirmar Pedido
                </b-button>
                <b-button
                  v-show="
                    (this.$store.getters['pedidoInfo'].pedido_id
                      ? false
                      : true) &&
                    this.fieldsInput[1].value &&
                    this.fieldsInput[2].value &&
                    this.fieldsInput[7].value
                  "
                  class="ml-2"
                  @click="gravaPedidos"
                  variant="secondary"
                >
                  Salvar
                </b-button>

                <b-button
                  class="ml-2"
                  @click="voltarListagemPedidos"
                  variant="danger"
                >
                  X
                </b-button>
              </b-col>
            </b-row>
          </template>

          <!-- <b-modal
          centered
          :key="key"
          no-close-on-esc
          no-close-on-backdrop
          v-model="show_modal_import"
          hide-footer
        >
          <PedidosImport
            :campanha="campanha"
            @onChangeCloseModal="
              show_modal_import
                ? (show_modal_import = false)
                : (show_modal_import = true)
            "
          />
        </b-modal> -->

          <ConfirmDialog :key="key" group="importarPedido">
            <template #message="slotProps">
              <div class="flex p-4">
                <i
                  :class="slotProps.message.icon"
                  style="font-size: 1.5rem"
                ></i>
                <p class="pl-2">{{ slotProps.message.message }}</p>
              </div>
            </template>
          </ConfirmDialog>

          <div class="row" :key="key">
            <div class="col-md-12 col-sm-6 col-lg-3">
              <b-form-group :label="fieldsInput[0].label">
                <SingleSelect
                  :slug="fieldsInput[0].slug"
                  :slugId="fieldsInput[0].slugId"
                  :slugDesc="fieldsInput[0].slugDesc"
                  :endpoint="fieldsInput[0].endpoint"
                  :required="fieldsInput[0].required"
                  :model="fieldsInput[0].value"
                  :disabled="fieldsInput[0].disabled"
                  @onChangeCombo="
                    (value) => {
                      fieldsInput[0].value = value
                      this.setPedidoPrincipalInfos()
                    }
                  "
                />
              </b-form-group>
            </div>
            <div class="col-md-12 col-sm-6 col-lg-3">
              <b-form-group :label="fieldsInput[1].label">
                <SingleSelectComplete
                  :slug="fieldsInput[1].slug"
                  :slugId="fieldsInput[1].slugId"
                  :slugDesc="fieldsInput[1].slugDesc"
                  :endpoint="fieldsInput[1].endpoint"
                  :required="fieldsInput[1].required"
                  :model="fieldsInput[1].value"
                  :disabled="fieldsInput[1].disabled"
                  @onChangeCombo="
                    (value) => {
                      fieldsInput[1].value = value
                      this.setPedidoPrincipalInfos()
                    }
                  "
                />
              </b-form-group>
            </div>
            <div class="col-md-12 col-sm-6 col-lg-2">
              <b-form-group :label="fieldsInput[7].label">
                <SingleSelect
                  :slug="fieldsInput[7].slug"
                  :slugId="fieldsInput[7].slugId"
                  :slugDesc="fieldsInput[7].slugDesc"
                  :endpoint="fieldsInput[7].endpoint"
                  :required="fieldsInput[7].required"
                  :model="fieldsInput[7].value"
                  :disabled="fieldsInput[7].disabled"
                  @onChangeCombo="
                    (value) => {
                      fieldsInput[7].value = value
                      this.setPedidoPrincipalInfos()
                      this.keyCondPGTO++
                      this.validaPedido()
                    }
                  "
                />
              </b-form-group>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-2">
              <b-form-group :label="fieldsInput[2].label">
                <SingleSelect
                  :key="this.keyCondPGTO"
                  :slug="fieldsInput[2].slug"
                  :slugId="fieldsInput[2].slugId"
                  :slugDesc="fieldsInput[2].slugDesc"
                  :endpoint="fieldsInput[2].endpoint"
                  :required="fieldsInput[2].required"
                  :model="fieldsInput[2].value"
                  :disabled="fieldsInput[2].disabled"
                  @onChangeCombo="
                    (value) => {
                      fieldsInput[2].value = value
                      this.setPedidoPrincipalInfos()
                      atualizaValorMinimoParcela()
                      this.getcondPgtoCampanha()
                      this.validaPedido()
                    }
                  "
                />
              </b-form-group>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-2">
              <b-form-group :label="fieldsInput[5].label">
                <PrimeCalendar
                  disabled
                  v-model="fieldsInput[5].value"
                  selectionMode="single"
                  dateFormat="dd/mm/yy"
                  :showTime="true"
                  hourFormat="24"
                  showIcon
                />
              </b-form-group>
            </div>

            <div class="col-md-6 col-sm-6 col-lg-6">
              <b-form-group :label="fieldsInput[6].label">
                <b-form-textarea
                  v-model="fieldsInput[6].value"
                  disabled
                  rows="7"
                  max-rows="15"
                ></b-form-textarea>
              </b-form-group>
            </div>

            <div class="col-md-6 col-sm-6 col-lg-6 mt-3">
              <div v-show="pedidoValido" class="bg-success text-white status">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-hand-thumbs-up mr-2"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2.144 2.144 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a9.84 9.84 0 0 0-.443.05 9.365 9.365 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111L8.864.046zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a8.908 8.908 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.224 2.224 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.866.866 0 0 1-.121.416c-.165.288-.503.56-1.066.56z"
                  />
                </svg>
                <span>{{ mensagem }}</span>
              </div>

              <div v-show="!pedidoValido" class="bg-danger text-white status">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-hand-thumbs-down mr-2"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8.864 15.674c-.956.24-1.843-.484-1.908-1.42-.072-1.05-.23-2.015-.428-2.59-.125-.36-.479-1.012-1.04-1.638-.557-.624-1.282-1.179-2.131-1.41C2.685 8.432 2 7.85 2 7V3c0-.845.682-1.464 1.448-1.546 1.07-.113 1.564-.415 2.068-.723l.048-.029c.272-.166.578-.349.97-.484C6.931.08 7.395 0 8 0h3.5c.937 0 1.599.478 1.934 1.064.164.287.254.607.254.913 0 .152-.023.312-.077.464.201.262.38.577.488.9.11.33.172.762.004 1.15.069.13.12.268.159.403.077.27.113.567.113.856 0 .289-.036.586-.113.856-.035.12-.08.244-.138.363.394.571.418 1.2.234 1.733-.206.592-.682 1.1-1.2 1.272-.847.283-1.803.276-2.516.211a9.877 9.877 0 0 1-.443-.05 9.364 9.364 0 0 1-.062 4.51c-.138.508-.55.848-1.012.964l-.261.065zM11.5 1H8c-.51 0-.863.068-1.14.163-.281.097-.506.229-.776.393l-.04.025c-.555.338-1.198.73-2.49.868-.333.035-.554.29-.554.55V7c0 .255.226.543.62.65 1.095.3 1.977.997 2.614 1.709.635.71 1.064 1.475 1.238 1.977.243.7.407 1.768.482 2.85.025.362.36.595.667.518l.262-.065c.16-.04.258-.144.288-.255a8.34 8.34 0 0 0-.145-4.726.5.5 0 0 1 .595-.643h.003l.014.004.058.013a8.912 8.912 0 0 0 1.036.157c.663.06 1.457.054 2.11-.163.175-.059.45-.301.57-.651.107-.308.087-.67-.266-1.021L12.793 7l.353-.354c.043-.042.105-.14.154-.315.048-.167.075-.37.075-.581 0-.211-.027-.414-.075-.581-.05-.174-.111-.273-.154-.315l-.353-.354.353-.354c.047-.047.109-.176.005-.488a2.224 2.224 0 0 0-.505-.804l-.353-.354.353-.354c.006-.005.041-.05.041-.17a.866.866 0 0 0-.121-.415C12.4 1.272 12.063 1 11.5 1z"
                  />
                </svg>
                <span>{{ mensagem }}</span>
              </div>

              <div
                class="text-white status mt-2"
                :class="{
                  'bg-danger': situacao_pedido_filiais.cor == 'vermelho',
                  'bg-success': situacao_pedido_filiais.cor == 'verde',
                  'bg-secondary': situacao_pedido_filiais.cor == 'cinza',
                }"
              >
                <span>{{ situacao_pedido_filiais.situacao }}</span>
              </div>
            </div>
          </div>
        </b-card>
      </b-form>
    </b-overlay>

    <b-row>
      <b-col class="col-md-12 col-sm-6 col-lg-12">
        <b-card class="mt-2">
          <template #header>
            <b-overlay :show="show_overlay" rounded="sm">
              <ListProduto
                :valorMinimoParcela="this.valorMinimoParcela"
                :pedidoPrincipalInfo="this.pedidoPrincipalInfo"
                :produtosImportados="this.produtosImportados"
                :filiais_key="this.filiais_key"
                @setSituacaoPedidosFiliais="setSituacaoPedidosFiliais"
                @setSubPedidosValidos="setSubPedidosValidos"
                @gravaPedidos="gravaPedidos"
                @atualizaTotalPedido="atualizaTotalPedido"
                @atualizaListaProdutos="atualizaListaProdutos"
                @backToList="back"
              ></ListProduto>
            </b-overlay>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { useRoute } from 'vue-router'
import { format } from 'v-money3'
import config from '@/functions/formatMoney'
import ListProduto from './ListProduto.vue'
import configDisable from '@/functions/formatMoneyDisable'
import service from '@/services/BaseService'
import moment from 'moment'
import { read, utils, writeFileXLSX } from 'xlsx'
import writeXlsxFile from 'write-excel-file'
import ConfirmDialog from 'primevue/confirmdialog'
//import PedidosImport from './PedidosImport.vue'

export default {
  components: { ListProduto, ConfirmDialog },
  props: {},
  setup() {
    const route = useRoute()
    return {
      configDisable: configDisable,
      route: route,
    }
  },
  data() {
    return {
      format: format,
      config: config,
      campanha: this.$store.getters['pedidoInfo'],
      table: 'CAM_PEDIDO',
      labelHeader: 'Pedido',
      positionModal: 'right',
      show_modal_import: false,
      pedidoValido: false,
      subPedidosValidos: true,
      show_overlay: false,
      mensagem: '',
      condPgtoID: this.$store.getters['pedidoInfo'].cam_cond_pgto_id || null,
      pedidoPrincipalInfo: {},
      filiais_key: 0,
      situacao_pedido_filiais: {
        situacao: 'Nenhum pedido para filiais!',
        cor: 'cinza',
      },
      interval_id: 0,
      keyCondPGTO: 0,
      valorMinimoParcela: 0,
      distribuidorEndpoint: `DISTRIBUIDOR/${this.$store.getters['pedidoInfo'].id}`,
      condpgtoEndpoint: `default/CAM_CAMPANHA_COND_PGTO/search/params?&cam_campanha_id=${this.$store.getters['pedidoInfo'].id}&distribuidor_id=${this.$store.getters['pedidoInfo'].cam_pessoa_id}&join=[{'table':'CAM_COND_PGTO','input':'ID','return':'DESC'}]`,
      listaPedidos: [],
      listaFiliais: [],
      fieldsFiliais: [
        { key: 'nomereduzido', label: 'Cód. Farmácia' },
        { key: 'email', label: 'Email' },
        { key: 'cnpjcpf', label: 'CNPJ' },
        { key: 'endereco', label: 'Endereço' },
      ],
      listaPedidosCampanha: [],
      condPgtoPedido: null,
      listaProdutosCampanha: [],
      expandedRows: [],
      produtosImportados: [],
      fieldsInput: [
        {
          disabled: true,
          label: 'Campanha',
          slug: 'cam_campanha_id',
          slugId: 'id',
          slugDesc: 'nome',
          endpoint: `default/CAM_CAMPANHA`,
          value: this.$store.getters['pedidoInfo'].id,
          type: 'combo',
          required: true,
        },
        {
          disabled: localStorage.getItem('admin') === 'false',
          label: 'Farmacia',
          slug: 'farmacia_id',
          slugId: 'id',
          slugDesc: 'nomereduzido',
          endpoint:
            localStorage.getItem('admin') === 'true'
              ? `default/FIN_CLIENTE/search/params?&${localStorage.getItem(
                  'var_source',
                )}&limit=999&diff_classe=03&sort=nomereduzido`
              : 'default/FIN_CLIENTE/search/params?',
          value: this.$store.getters['pedidoInfo'].farmacia_id,
          type: 'combo',
          required: true,
        },
        {
          label: 'Condição de Pagamento',
          slug: 'cam_cond_pgto_id',
          slugId: 'cam_cond_pgto_id',
          slugDesc: 'cam_cond_pgto_desc',
          endpoint: null,
          value: this.$store.getters['pedidoInfo'].cam_cond_pgto_id || null,
          type: 'combo',
          required: true,
        },
        {
          slug: 'valor_minimo',
          label: 'Valor Minimo',
          value: this.$store.getters['pedidoInfo'].valor_minimo || 0,
          type: 'moneyDisable',
          required: true,
        },
        {
          label: 'Total',
          slug: 'total',
          value: this.$store.getters['pedidoInfo'].total || 0,
          type: 'moneyDisable',
          required: true,
        },
        {
          label: 'Emissão',
          slug: 'emissao',
          value: this.$store.getters['pedidoInfo'].emissao
            ? moment(
                this.$store.getters['pedidoInfo'].emissao,
                'YYYY-MM-DD HH:mm',
              ).format('DD/MM/YYYY H:mm')
            : moment().format('YYYY-MM-DD HH:mm'),
          type: 'datetime',
          required: true,
        },
        {
          slug: 'observacao',
          label: 'Observação Campanha',
          value:
            `Preço Final ST: ${this.$store.getters['pedidoInfo'].preco_final_st}` +
            '\n' +
            `Observação Campanha: ${this.$store.getters['pedidoInfo'].obs}`,
          type: 'textarea',
        },
        {
          label: 'Distribuidor',
          slug: 'cam_pessoa_id',
          slugId: 'pessoa_id',
          slugDesc: 'nomereduzido',
          endpoint: `DISTRIBUIDOR/${this.$store.getters['pedidoInfo'].id}`,
          value: this.$store.getters['pedidoInfo'].cam_pessoa_id || null,
          type: 'combo',
          required: true,
        },
      ],
      form: {},
      produtos: [],
      key: 0,
      admin: localStorage.getItem('admin') === 'true',
    }
  },
  async created() {
    this.atualizaValorMinimoParcela()
    this.setPedidoPrincipalInfos()

    this.getListaProdutosCampanha()
    this.getcondPgtoCampanha()
    this.getFarmacia()

    this.setSubPedidosValidos(this.subPedidosValidos)
    await this.validaPedido()
  },
  mounted() {
    this.interval_id = window.setInterval(() => {
      this.$toast.warning('Salve pedidos em aberto para não perder os dados!')
    }, 900000)
  },
  methods: {
    setSituacaoPedidosFiliais(situacao) {
      this.situacao_pedido_filiais = situacao
    },

    async getCNPJS() {
      this.show_overlay = true
      var farmaciaMatriz = {}
      const httpFarmacia = new service(
        `default/FIN_CLIENTE/search/params?id=${this.pedidoPrincipalInfo.farmacia_id}`,
      )
      await httpFarmacia.find().then((resp) => {
        farmaciaMatriz = resp.data.response[0]
      })

      var cnpjs = []
      if (farmaciaMatriz) {
        var http = new service(
          `default/FIN_CLIENTE/search/params?&email=${
            farmaciaMatriz.email
          }&${localStorage.getItem('var_source')}&limit=999&diff_classe=03`,
        )
        await http.find().then((resp) => {
          cnpjs = resp.data.response.map((item) => {
            return item.cnpjcpf
          })
        })
      } else {
        this.$toast.warning(
          'Ocorreu um erro ao buscar os CNPJs das farmácias filiais!',
        )
      }

      this.show_overlay = false

      return cnpjs
    },
    async downloadProdutosCampanha() {
      const cnpjs = await this.getCNPJS()
      var listaProdutos = []
      var http = new service(
        `default/CAM_CAMPANHA_PRODUTO/search/params?cam_campanha_id=${this.campanha.id}&limit=999&sort=descricao`,
      )
      await http.find().then((resp) => {
        // precisa mapear cada cpnj para cada produto
        listaProdutos = resp.data.response.map((produto) => {
          return cnpjs.map((cnpj) => {
            return {
              cnpj: cnpj,
              cean: produto.cean,
              descricao: produto.descricao,
              valor_unitario: produto.valor_unitario,
            }
          })
        })

        listaProdutos = [].concat.apply([], listaProdutos)
        listaProdutos.sort((a, b) => {
          return a.cnpj - b.cnpj
        })
      })
      const fileName = `exportacao_Big_Linx_${this.campanha.id}.xlsx`
      const listExport = listaProdutos.map((item) => {
        // Layout do arquivo de acordo com o solicitado via email
        return {
          CNPJ: item.cnpj ? item.cnpj : '',
          LOJA: '',
          COD_PRODUTO: '',
          EAN: item.cean,
          'DESCRIÇÃO PRODUTO': item.descricao,
          QUANTIDADE: '',
          PREÇO: parseFloat(item.valor_unitario),
          DESCONTO: '',
          'LABORATÓRIO/INDÚSTRIA': '',
        }
      })
      const ws = utils.json_to_sheet(listExport)
      const wb = utils.book_new()
      utils.book_append_sheet(wb, ws, 'Data')
      writeFileXLSX(wb, fileName)
    },
    async getFarmacia() {
      this.show_overlay = true

      const httpFarmacia = new service(
        `default/FIN_CLIENTE/search/params?id=${this.fieldsInput[1].value}`,
      )
      await httpFarmacia.find().then((resp) => {
        this.farmaciaPrincipal = resp.data.response[0]
      })

      this.show_overlay = false
    },
    async exportarPedido() {
      this.show_overlay = true
      var pedido = this.$store.getters['pedidoInfo']
      var pedidos = []

      const http = new service(`CAM_PEDIDO/${pedido.campanha_id}`)
      await http.find().then((resp) => {
        pedidos = resp.data.response.filter((p) => {
          return pedido.pedido_id == p.id
        })
      })

      await this.getProdutosPedidos(pedidos)

      this.show_overlay = false
    },

    async getProdutosPedidos(pedidos) {
      this.show_overlay = true
      var listaProdutos = []
      if (pedidos.length > 0) {
        for (let i = 0; i < pedidos.length; i++) {
          const http = new service(
            `default/CAM_PEDIDO_PRODUTO/search/params?cam_pedido_id=${pedidos[i].id}&limit=999`,
          )
          await http.find().then((resp) => {
            const produtos = resp.data.response.filter((produto) => {
              if (
                parseInt(produto.quant_solicitada) > 0 ||
                produto.quant_solicitada != null
              ) {
                return produto
              }
            })
            produtos.forEach((produto) => {
              listaProdutos.push({
                ...produto,
                ...pedidos[i],
              })
            })
          })
        }

        this.geraPlanilhaXLSX(listaProdutos)
      } else {
        this.$toast.warning(
          'Houve um erro ao consultar o pedido para exportação!',
        )
      }
      this.show_overlay = false
    },

    async geraPlanilhaXLSX(listaProdutos) {
      this.show_overlay = true
      if (listaProdutos.length > 0) {
        const idCampanha = this.campanha.identificacao
        const nomeCampanha = this.campanha.nome
        const data_fim = moment(
          this.campanha.data_fim,
          'YYYY-MM-DD HH:mm',
        ).format('DD/MM/YYYY HH:mm')
        const total = format(
          listaProdutos.reduce((acc, cur) => {
            return (
              acc +
              parseFloat(cur.quant_solicitada) * parseFloat(cur.valor_unitario)
            )
          }, 0),
          config,
        )

        var data = []
        data.push([{ value: `Identificação da Campanha: ${idCampanha}` }])
        data.push([{ value: `Nome da Campanha: ${nomeCampanha}` }])
        data.push([
          {
            value: `Prazo Final da Campanha: ${data_fim}`,
          },
        ])
        data.push([])
        data.push([
          {
            value: `Valor Total do(s) Pedido(s): ${total}`,
            backgroundColor: '#e0f731',
          },
        ])

        data.push([])
        const columns = [
          {
            value: 'Loja',
            fontWeight: 'bold',
            backgroundColor: '#a6aebd',
            align: 'center',
          },
          {
            value: 'CNPJ',
            fontWeight: 'bold',
            backgroundColor: '#a6aebd',
            align: 'center',
          },
          {
            value: 'Distribuidor Selecionado',
            fontWeight: 'bold',
            backgroundColor: '#a6aebd',
            align: 'center',
          },
          {
            value: 'UF',
            fontWeight: 'bold',
            backgroundColor: '#a6aebd',
            align: 'center',
          },
          {
            value: 'Cidade',
            fontWeight: 'bold',
            backgroundColor: '#a6aebd',
            align: 'center',
          },
          {
            value: 'Condição de Pagamento',
            fontWeight: 'bold',
            backgroundColor: '#a6aebd',
            align: 'center',
          },
          {
            value: 'Nº do Pedido',
            fontWeight: 'bold',
            backgroundColor: '#a6aebd',
            align: 'center',
          },
          {
            value: 'Data do Pedido',
            fontWeight: 'bold',
            backgroundColor: '#a6aebd',
            align: 'center',
          },
          {
            value: 'Código EAN',
            fontWeight: 'bold',
            backgroundColor: '#a6aebd',
            align: 'center',
          },
          {
            value: 'Produto',
            fontWeight: 'bold',
            backgroundColor: '#a6aebd',
            align: 'center',
          },
          {
            value: 'Indústria',
            fontWeight: 'bold',
            backgroundColor: '#a6aebd',
            align: 'center',
          },
          {
            value: 'Quantidade',
            fontWeight: 'bold',
            backgroundColor: '#a6aebd',
            align: 'center',
          },
          {
            value: 'Valor Unitário',
            fontWeight: 'bold',
            backgroundColor: '#a6aebd',
            align: 'center',
          },
          {
            value: 'Valor Total',
            fontWeight: 'bold',
            backgroundColor: '#a6aebd',
            align: 'center',
          },
        ]
        data.push(columns)

        //const prazo = moment(campanha.data_fim).format('DD/MM/YYYY HH:mm')

        listaProdutos = listaProdutos.filter(
          (produto) => parseInt(produto.quant_solicitada) > 0,
        )

        listaProdutos.forEach((produto) => {
          data.push([
            {
              value: produto.fin_cliente_nomereduzido
                ? produto.fin_cliente_nomereduzido
                : '',
              type: String,
              align: 'center',
            },
            {
              value: produto.cnpjcpf ? produto.cnpjcpf : '',
              type: String,
              align: 'center',
            },
            {
              value: produto.cam_pessoa_nome ? produto.cam_pessoa_nome : '',
              type: String,
              align: 'center',
            },
            {
              value: produto.uf ? produto.uf : '',
              type: String,
              align: 'center',
            },
            {
              value: produto.cidade ? produto.cidade : '',
              type: String,
              align: 'center',
            },
            {
              value: produto.cam_cond_pgto_desc
                ? produto.cam_cond_pgto_desc
                : '',
              type: String,
              align: 'center',
            },
            {
              value: produto.cam_pedido_id ? produto.cam_pedido_id : '',
              type: Number,
              align: 'center',
            },
            {
              value: produto.created_at
                ? new Date(produto.created_at)
                : new Date(produto.created_at),
              type: Date,
              format: 'dd/mm/yyyy hh:mm',
              align: 'center',
            },
            {
              value: produto.cean ? produto.cean : '',
              type: String,
              align: 'center',
            },
            {
              value: produto.descricao ? produto.descricao : '',
              type: String,
              align: 'center',
            },
            {
              value: produto.laboratorio ? produto.laboratorio : '',
              type: String,
              align: 'center',
            },
            {
              value: parseInt(produto.quant_solicitada),
              type: Number,
              align: 'center',
            },
            {
              value: parseFloat(produto.valor_unitario),
              type: Number,
              format: '#,##0.00',
              align: 'center',
            },
            {
              value:
                parseFloat(produto.quant_solicitada) *
                parseFloat(produto.valor_unitario),
              type: Number,
              format: '#,##0.00',
              align: 'center',
            },
          ])
        })

        var prefixo = ''
        if (listaProdutos.length > 1) {
          prefixo = `exportacao_pedidos_nao_enviados - ${this.campanha.nome}`
        } else {
          prefixo = `pedido_${listaProdutos[0].fin_cliente_nomereduzido} - ${this.campanha.nome}`
        }
        const fileName = `${prefixo}.xlsx`
        await writeXlsxFile(data, { fileName })
      } else {
        this.$toast.warning(
          'Houve um erro ao consultar o pedido para exportação!',
        )
      }

      await this.getList()
      this.show_overlay = false
    },

    async importarPedido() {
      this.$confirm.require({
        group: 'importarPedido',
        message: `As quantidades digitas serão substituídas pelas as da planilha importada. Deseja continuar?`,
        header: 'Confirmação de importação de pedido!',
        icon: 'pi pi-info-circle',
        acceptClass: 'p-button-success',
        accept: async () => {
          try {
            const f = await document
              .getElementById('sheet')
              .files[0].arrayBuffer()
            const wb = read(f)
            var produtos = utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])

            if (produtos) {
              // separar lista de ṕrodutos da campanha por filial
              var pedidosFarmacias = []
              for (let i = 0; i < produtos.length; i++) {
                var produto = produtos[i]
                let cnpj_formatado = (produto.CNPJ + '').padStart(14, '0')
                var filial = pedidosFarmacias.find(
                  (f) => f.cnpjcpf == cnpj_formatado,
                )
                if (!filial) {
                  pedidosFarmacias.push({
                    cnpjcpf: cnpj_formatado,
                    produtosPedido: JSON.parse(
                      JSON.stringify(this.listaProdutosCampanha),
                    ),
                  })
                }
              }

              var farmacias = await this.getFarmacias()
              for (let i = 0; i < farmacias.length; i++) {
                for (let j = 0; j < pedidosFarmacias.length; j++) {
                  if (farmacias[i].cnpjcpf == pedidosFarmacias[j].cnpjcpf) {
                    pedidosFarmacias[j] = {
                      mensagem: '',
                      ...pedidosFarmacias[j],
                      id: farmacias[i].id,
                      uf: farmacias[i].uf,
                      ehValido: false,
                      fazer_pedido: true,
                      nome: farmacias[i].nome,
                      email: farmacias[i].email,
                      condPgtoId: this.fieldsInput[2].value || null,
                      endereco: farmacias[i].endereco,
                      nomereduzido: farmacias[i].nomereduzido,
                    }
                  }
                }
              }

              // preencher lista de produtos da planilha por filial
              for (let i = 0; i < produtos.length; i++) {
                produto = produtos[i]
                let cnpj_formatado = (produto.CNPJ + '').padStart(14, '0')
                for (let j = 0; j < pedidosFarmacias.length; j++) {
                  if (pedidosFarmacias[j].cnpjcpf == cnpj_formatado) {
                    var pedido = pedidosFarmacias[j]
                    for (let k = 0; k < pedido.produtosPedido.length; k++) {
                      if (pedido.produtosPedido[k].cean == produto.EAN)
                        pedido.produtosPedido[k].quant_solicitada = parseInt(
                          produto.QUANTIDADE,
                        )
                    }
                  }
                }
              }

              for (let x = 0; x < pedidosFarmacias.length; x++) {
                if (pedidosFarmacias[x].id == this.fieldsInput[1].value) {
                  this.produtosImportados = pedidosFarmacias[x].produtosPedido
                  pedidosFarmacias.splice(x, 1)
                }
              }

              pedidosFarmacias.forEach(async (filial) => {
                await this.validaPedidoFilial(filial)
              })

              this.$store.commit({
                type: 'setMultiplosPedidos',
                value: pedidosFarmacias,
              })

              this.filiais_key++
            } else {
              this.$toast.warning('Não foi possível importar o arquivo!')
            }
          } catch (err) {
            this.$toast.warning(err.message)
          }
        },
      })

      //this.show_modal_import = true
    },

    async getFarmacias() {
      this.show_overlay = true
      var farmaciaMatriz = {}
      const httpFarmacia = new service(
        `default/FIN_CLIENTE/search/params?id=${this.pedidoPrincipalInfo.farmacia_id}`,
      )
      await httpFarmacia.find().then((resp) => {
        farmaciaMatriz = resp.data.response[0]
      })

      var farmacias = []
      if (farmaciaMatriz) {
        var http = new service(
          `default/FIN_CLIENTE/search/params?&email=${
            farmaciaMatriz.email
          }&${localStorage.getItem('var_source')}&limit=999&diff_classe=03`,
        )
        await http.find().then((resp) => {
          farmacias = resp.data.response
        })
      } else {
        this.$toast.warning(
          'Ocorreu um erro ao buscar os CNPJs das farmácias filiais!',
        )
      }

      this.show_overlay = false

      return farmacias
    },

    async salvaSubpedidos() {
      const subpedidos = this.$store.getters['multiplosPedidos']

      if (subpedidos.length > 0) {
        const mensagem = 'Esta farmácia já possui pedido para esta campanha!'
        for (let i = 0; i < subpedidos.length; i++) {
          this.validaFarmaciarRepetida(subpedidos[i])
          if (
            subpedidos[i].mensagem !== mensagem &&
            subpedidos[i].fazer_pedido
          ) {
            var produtos = subpedidos[i].produtosPedido
            var totalPedido = this.calculaValorSubpedido(produtos)
            await this.validaPedidoFilial(subpedidos[i])
            var pedido = {
              cam_campanha_id: this.pedidoPrincipalInfo.cam_campanha_id,
              cam_cond_pgto_id: this.pedidoPrincipalInfo.cam_cond_pgto_id,
              cam_pessoa_id: this.pedidoPrincipalInfo.cam_pessoa_id,
              farmacia_id: subpedidos[i].id,
              total: totalPedido,
              situacao: subpedidos[i].ehValido === true ? 'P' : 'A',
              created_user: parseInt(this.$store.getters['user'].usuario),
            }

            var http = new service(`${this.table}`)
            await http
              .create({ pedido: pedido, produtos: produtos })
              .then(() => {})
              .catch((e) => {
                console.log(e.response.data.message)
              })
          }
        }
      }
    },
    async salvaPedido() {
      this.setInputs()

      var pedido = this.form
      pedido.situacao = this.pedidoValido === true ? 'P' : 'A'
      const pedidoID = this.$store.getters['pedidoInfo'].pedido_id
      pedido.created_user = parseInt(this.$store.getters['user'].usuario)
      pedido.id = pedidoID ? pedidoID : null
      var produtos = this.produtos
      delete pedido.cam_campanha_nome
      delete pedido.cam_cond_pgto_desc
      delete pedido.emissao
      delete pedido.valor_minimo
      delete pedido.observacao
      var http = new service(`${this.table}`)
      await http
        .create({ pedido: pedido, produtos: produtos })
        .then(() => {})
        .catch((e) => {
          this.$toast.error(e.response.data.message)
        })

      await this.salvaSubpedidos()
    },
    setSubPedidosValidos(status) {
      if (this.$store.getters['multiplosPedidos']) {
        this.subPedidosValidos = status
      } else {
        this.subPedidosValidos = this.pedidoValido
      }
    },
    setPedidoPrincipalInfos() {
      this.pedidoPrincipalInfo.cam_campanha_id = this.fieldsInput[0].value
      this.pedidoPrincipalInfo.farmacia_id = this.fieldsInput[1].value
      this.pedidoPrincipalInfo.cam_cond_pgto_id = this.fieldsInput[2].value
      this.pedidoPrincipalInfo.valor_minimo = this.fieldsInput[3].value
      this.pedidoPrincipalInfo.total = this.fieldsInput[4].value
      this.pedidoPrincipalInfo.emissao = this.fieldsInput[5].value
      this.pedidoPrincipalInfo.observacao = this.fieldsInput[6].value
      this.pedidoPrincipalInfo.cam_pessoa_id = this.fieldsInput[7].value
      this.pedidoPrincipalInfo.situacao =
        this.$store.getters['pedidoInfo'].situacao
      this.$store.commit({
        type: 'setPedidoInfo',
        value: {
          ...this.$store.getters['pedidoInfo'],
          cam_pessoa_id: this.pedidoPrincipalInfo.cam_pessoa_id,
        },
      })
      const distribuidor_id = this.fieldsInput[7].value
      this.condpgtoEndpoint = `default/CAM_CAMPANHA_COND_PGTO/search/params?&cam_campanha_id=${this.$store.getters['pedidoInfo'].id}&distribuidor_id=${distribuidor_id}&join=[{'table':'CAM_COND_PGTO','input':'ID','return':'DESC'}]`
      this.fieldsInput[2].endpoint = this.condpgtoEndpoint

      this.keyCondPGTO++
    },
    atualizaTotalPedido(total) {
      this.fieldsInput[4].value = total
      this.validaPedido()
    },
    async getListaProdutosCampanha() {
      this.show_overlay = true
      const campanhaId = this.fieldsInput[0].value
      var http = new service(
        `default/CAM_CAMPANHA_PRODUTO/search/params?cam_campanha_id=${campanhaId}&limit=999&sort=descricao`,
      )
      await http
        .find()
        .then((resp) => {
          this.listaProdutosCampanha = resp.data.response.map((item) => {
            delete item.id
            delete item.created_user
            delete item.created_at
            return { ...item, quant_solicitada: 0 }
          })

          this.listaProdutosCampanha.sort((a, b) => {
            if (a.descricao < b.descricao) {
              return -1
            }
            if (a.descricao > b.descricao) {
              return 1
            }
            return 0
          })

          /* this.calculaValorMinimo()
          this.calculaValorTotal()

          this.$emit('atualizaListaProdutos', this.list) */
          this.show_overlay = false
          // this.key++
        })
        .catch(() => {
          this.show_overlay = false
          // this.key++
        })
    },
    async validaPedidoFilial(filial) {
      this.validaQuantidade(filial)
      this.validaFarmaciarRepetida(filial)
      this.validaCondPgto(filial)

      if (filial.ehValido) {
        filial.mensagem = 'Pedido Válido'
      }
    },
    validaQuantidade(filial) {
      const produtos = filial.produtosPedido
      for (let i = 0; i < produtos.length; i++) {
        if (
          (produtos[i].compra_obrigatorio == 'S' &&
            parseInt(produtos[i].quant_solicitada) <
              parseInt(produtos[i].quant_minima)) ||
          (parseInt(produtos[i].quant_minima) >
            parseInt(produtos[i].quant_solicitada) &&
            parseInt(produtos[i].quant_minima) > 0 &&
            parseInt(produtos[i].quant_solicitada) > 0)
        ) {
          filial.mensagem =
            'Quantidade mínima de produtos não atingida! Verifique a quantidade dos produtos.'
          filial.ehValido = false

          break
        }
      }
    },
    async validaFarmaciarRepetida(filial) {
      for (let j = 0; j < this.listaPedidosCampanha.length; j++) {
        if (this.listaPedidosCampanha[j].farmacia_id == filial.id) {
          filial.mensagem = 'Esta farmácia já possui pedido para esta campanha!'
          filial.ehValido = false
          break
        }
      }
    },
    validaCondPgto(filial) {
      const listaProdutos = filial.produtosPedido
      var valorTotal = 0
      for (let i = 0; i < listaProdutos.length; i++) {
        const produto = listaProdutos[i]
        valorTotal += parseFloat(
          parseInt(produto.quant_solicitada) *
            parseFloat(produto.valor_unitario),
        )
      }
      const valorParcelaPedido =
        valorTotal / parseInt(this.condPgtoPedido.numero_parcelas)
      if (
        valorParcelaPedido < parseInt(this.condPgtoPedido.valor_minimo_parcela)
      ) {
        filial.mensagem =
          'Valor das parcelas do pedido é inferior ao valor mínimo de parcela da condição de pagamento selecionada!'
        filial.ehValido = false
      }
    },
    async getcondPgtoCampanha() {
      const campanhaId = this.fieldsInput[0].value
      const condPgtoID = this.fieldsInput[2].value
      const httpCondPgto = new service(
        `default/CAM_CAMPANHA_COND_PGTO/search/params?&cam_campanha_id=${campanhaId}&join=[{'table':'CAM_COND_PGTO','input':'ID','return':'DESC,NUMERO_PARCELAS'}]`,
      )
      this.condPgtoPedido = await httpCondPgto.find().then((resp) => {
        return resp.data.response.find(
          (item) => item.cam_cond_pgto_id == condPgtoID,
        )
      })
    },
    async getListaPedidos() {
      this.show_overlay = true
      const campanhaId = this.$store.getters['pedidoInfo'].campanha_id
      var http = new service(`CAM_PEDIDO/${campanhaId}`)
      await http.find().then((resp) => {
        this.listaPedidos = resp.data.response
        this.show_overlay = false
        this.key++
      })
    },
    async atualizaValorMinimoParcela() {
      const campanhaId = this.$store.getters['pedidoInfo'].id
      var httpCondPgto = new service(
        `default/CAM_CAMPANHA_COND_PGTO/search/params?cam_campanha_id=${campanhaId}&cam_cond_pgto_id=${this.fieldsInput[2].value}`,
      )
      await httpCondPgto
        .find()
        .then((resp) => {
          this.valorMinimoParcela = parseFloat(
            resp.data.response[0].valor_minimo_parcela,
          )
          this.pedidoPrincipalInfo.valor_minimo = parseFloat(
            resp.data.response[0].valor_minimo_parcela,
          )
        })
        .catch(() => {})

      this.validaPedido()
    },
    async validaPedido() {
      const condicaoPagamentoValida = await this.validaCondicaoPagamento()
      const produtosValidos = this.validaProdutos()
      const farmaciaValida = this.validaFarmacia()
      const formValido = this.validaForm()

      this.pedidoValido =
        produtosValidos &&
        farmaciaValida &&
        condicaoPagamentoValida &&
        formValido

      if (this.pedidoValido) {
        this.mensagem = 'Pedido Válido!'
      }
    },
    atualizaListaProdutos(listaProdutos) {
      this.produtos = listaProdutos
      this.validaPedido()
    },
    onChangeForm(item) {
      this.$emit('onChangeForm', item)
    },
    onChangeCloseModal() {
      this.$emit('onChangeCloseModal')
    },
    setInputs() {
      this.fieldsInput.forEach((field) => {
        this.form[field.slug] = field.value
      })
    },
    validaForm() {
      let formValido = true
      const distribuidor = this.fieldsInput[7].value
      const condPgto = this.fieldsInput[2].value

      if (!distribuidor) {
        this.mensagem = 'Selecione um distribuidor!'
        //this.pedidoValido = false
        formValido = false
      } else if (!condPgto) {
        this.mensagem = 'Selecione uma condição de pagamento!'
        //this.pedidoValido = false
        formValido = false
      }

      return formValido
    },
    validaProdutos() {
      const valorMinimo = this.fieldsInput[3].value
      const valorTotal = this.fieldsInput[4].value
      var produtosValidos = true
      if (valorTotal < valorMinimo) {
        this.mensagem = 'Valor total do pedido menor que o valor mínimo!'
        produtosValidos = false
      } else {
        for (let i = 0; i < this.produtos.length; i++) {
          if (
            this.produtos[i].quant_solicitada == '' ||
            this.produtos[i].quant_solicitada == 0 ||
            isNaN(this.produtos[i].quant_solicitada)
          ) {
            this.produtos[i].quant_solicitada = null
          }
          if (
            (this.produtos[i].compra_obrigatorio === 'S' &&
              parseInt(this.produtos[i].quant_solicitada) <
                parseInt(this.produtos[i].quant_minima)) ||
            (parseInt(this.produtos[i].quant_minima) >
              parseInt(this.produtos[i].quant_solicitada) &&
              parseInt(this.produtos[i].quant_minima) > 0 &&
              parseInt(this.produtos[i].quant_solicitada) > 0) ||
            (this.produtos[i].quant_solicitada === null &&
              this.produtos[i].compra_obrigatorio === 'S') ||
            (this.produtos[i].quant_solicitada === null &&
              this.produtos[i].compra_obrigatorio === 'S')
          ) {
            this.mensagem =
              'Quantidade mínima de produtos não atingida! Verifique a quantidade dos produtos.'
            produtosValidos = false

            break
          }
        }
      }

      return produtosValidos
    },
    validaFarmacia() {
      var farmaciaValida = true
      for (let j = 0; j < this.listaPedidos.length; j++) {
        if (
          !this.item.isUpdating &&
          this.listaPedidos[j].farmacia_id == this.fieldsInput[1].value
        ) {
          this.mensagem = 'Esta farmácia já possui pedido para esta campanha!'
          farmaciaValida = false
          break
        }
      }

      return farmaciaValida
    },
    async validaCondicaoPagamento() {
      var condicaoPagamentoValida = true
      const condPgtoID = this.fieldsInput[2].value
      const campanhaId = this.$store.getters['pedidoInfo'].id
      const httpCondPgto = new service(
        `default/CAM_CAMPANHA_COND_PGTO/search/params?&cam_campanha_id=${campanhaId}&join=[{'table':'CAM_COND_PGTO','input':'ID','return':'DESC,NUMERO_PARCELAS'}]`,
      )
      const condPgto = await httpCondPgto.find().then((resp) => {
        return resp.data.response.find(
          (item) => item.cam_cond_pgto_id == condPgtoID,
        )
      })

      const valorParcelaPedido =
        parseInt(this.fieldsInput[4].value) / parseInt(condPgto.numero_parcelas)
      if (valorParcelaPedido < parseFloat(condPgto.valor_minimo_parcela)) {
        this.mensagem =
          'Valor das parcelas do pedido é inferior ao valor mínimo de parcela da condição de pagamento selecionada!'
        condicaoPagamentoValida = false
      }

      return condicaoPagamentoValida
    },
    back() {
      window.clearInterval(this.interval_id)
      /* this.$store.commit({
        type: 'setMultiplosPedidos',
        value: [],
      }) */
      if (this.admin) {
        const campanhaId = this.pedidoPrincipalInfo.cam_campanha_id
        this.$router.push(`/pedidos/${campanhaId}`)
      } else {
        const campanhaId = this.pedidoPrincipalInfo.cam_campanha_id
        const matrizId = this.$store.getters['user'].id
        this.$router.push(`/pedido-farmacias/${campanhaId}/${matrizId}`)
      }
    },
    voltarListagemPedidos() {
      this.$confirm.require({
        group: 'importarPedido',
        message: `Deseja voltar para a listagem de pedidos? Todas as alterações serão perdidas!`,
        header: 'Voltar Para Listagem de Pedidos',
        icon: 'pi pi-info-circle',
        acceptClass: 'p-button-success',
        accept: async () => {
          window.clearInterval(this.interval_id)
          this.$store.commit({
            type: 'setMultiplosPedidos',
            value: [],
          })

          if (this.admin) {
            this.$router.push({
              path: `/pedidos/${this.campanha.id}`,
            })
          } else {
            this.$router.push({
              path: `/pedido-farmacias/${this.campanha.id}/${this.fieldsInput[1].value}`,
              params: {
                id: this.campanha.id,
                farmacia_matriz_id: this.fieldsInput[1].value,
              },
            })
          }
        },
      })
    },
    validaSubPedidos() {
      const subpedidos = this.$store.getters['multiplosPedidos']
      var subpedidosValidos = true
      if (subpedidos.length > 0) {
        for (let i = 0; i < subpedidos.length; i++) {
          if (!subpedidos[i].ehValido && subpedidos[i].fazer_pedido) {
            subpedidosValidos = false
            break
          }
        }
      }

      return subpedidosValidos
    },
    calculaValorSubpedido(listaProdutos) {
      var valorTotal = 0
      for (let i = 0; i < listaProdutos.length; i++) {
        valorTotal += parseFloat(
          parseFloat(listaProdutos[i].valor_unitario) *
            parseInt(listaProdutos[i].quant_solicitada),
        )
      }

      return valorTotal
    },
    async realizaSubPedidos() {
      this.show_overlay = true
      const subpedidos = this.$store.getters['multiplosPedidos']
      if (subpedidos.length > 0) {
        for (let i = 0; i < subpedidos.length; i++) {
          var produtos = subpedidos[i].produtosPedido
          var temQuantidade = false
          for (let i = 0; i < produtos.length; i++) {
            if (produtos[i].quant_solicitada == '') {
              produtos[i].quant_solicitada = null
            }
            if (parseInt(produtos[i].quant_solicitada) > 0) {
              temQuantidade = true
            }
          }

          if (!temQuantidade) {
            this.$toast.warning(
              `Não houveram produtos no pedido da ${subpedidos[i].nomereduzido}. Realize o pedido novamente!`,
            )
          } else {
            var totalPedido = this.calculaValorSubpedido(produtos)
            var pedido = {
              cam_campanha_id: this.pedidoPrincipalInfo.cam_campanha_id,
              cam_cond_pgto_id: this.pedidoPrincipalInfo.cam_cond_pgto_id,
              cam_pessoa_id: this.pedidoPrincipalInfo.cam_pessoa_id,
              farmacia_id: subpedidos[i].id,
              total: totalPedido,
              situacao: subpedidos[i].ehValido ? 'P' : 'A',
              created_user: parseInt(this.$store.getters['user'].usuario),
            }

            if (subpedidos[i].fazer_pedido && subpedidos[i].ehValido) {
              var http = new service(`${this.table}`)
              await http
                .create({ pedido: pedido, produtos: produtos })
                .then((resp) => {
                  this.$emit('onChangeForm', resp.data.response)
                })
                .catch((e) => {
                  this.$toast.error(e.response.data.message)
                })
            }
          }
        }

        this.$store.commit({
          type: 'setMultiplosPedidos',
          value: [],
        })
        await this.getListaPedidos()
        this.$toast.success('Pedidos(s) Realizado(s) Com Sucesso!')
      }

      this.show_overlay = false
    },
    async onSubmit() {
      const data_fim = new Date(
        new Date(this.campanha.data_fim).setHours(
          new Date(this.campanha.data_fim).getHours() + 3,
        ),
      )
      const agora = new Date()
      if (agora > data_fim) {
        this.$toast.warning(
          'Campanha encerrada. Não é possível realizar pedidos! Acione o administrador do sistema.',
        )
        this.show_overlay = false
        window.clearInterval(this.interval_id)
        return
      }

      this.show_overlay = true
      this.setInputs()

      var temQuantidade = false
      for (let i = 0; i < this.produtos.length; i++) {
        if (this.produtos[i].quant_solicitada == '') {
          this.produtos[i].quant_solicitada = null
        }
        if (parseInt(this.produtos[i].quant_solicitada) > 0) {
          temQuantidade = true
        }
      }

      if (!temQuantidade) {
        this.$toast.warning(
          'Não há produtos para serem gravados. Por favor, altere a quantidade de ao menos um produto!',
        )
        this.show_overlay = false
        return
      }

      const condPgtoValida = await this.validaCondicaoPagamento()
      const produtosValidos = this.validaProdutos()
      const farmaciaValida = this.validaFarmacia()
      const subpedidosValidos = this.validaSubPedidos()

      if (condPgtoValida) {
        if (farmaciaValida) {
          if (produtosValidos == true) {
            if (subpedidosValidos) {
              var pedido = this.form
              const pedidoID = this.$store.getters['pedidoInfo'].pedido_id
              pedido.id = pedidoID ? pedidoID : null
              pedido.situacao = pedido.situacao || 'A'
              pedido.created_user = parseInt(
                this.$store.getters['user'].usuario,
              )
              var produtos = this.produtos
              delete pedido.cam_campanha_nome
              delete pedido.cam_cond_pgto_desc
              delete pedido.valor_minimo
              delete pedido.observacao

              const endpoint = `${this.table}`
              var http = new service(endpoint)
              await http
                .create({
                  pedido: pedido,
                  produtos: produtos,
                  validaPedidoDuplicado:
                    this.campanha.maispedidos == 'S' ? false : true,
                })
                .then((resp) => {
                  this.$toast.success('Pedidos(s) Realizado(s) Com Sucesso!!')
                  this.$emit('onChangeForm', resp.data.response)
                })
                .catch((e) => {
                  this.$toast.error(e.response.data.message)
                })

              await this.realizaSubPedidos()

              this.$store.commit({
                type: 'setMultiplosPedidos',
                value: [],
              })
            } else {
              this.$toast.warning(
                'Há inconsistências nos subpedidos. Verifique os campos em vermelho.',
              )
            }
          } else {
            this.$toast.warning(
              'Existem produtos que não atingiram a quantidade mínima estipulada!',
            )
          }
        } else {
          this.$toast.warning(
            'Esta farmácia já possui um pedido para esta campanha!',
          )
        }
      } else {
        this.$toast.warning(
          'O valor das parcelas é inferior ao valor mínimo estipulado para esta condição de pagamento!',
        )
      }

      this.show_overlay = false
      window.clearInterval(this.interval_id)
      this.back()
    },
    async confirmaPedido() {
      this.form.situacao = 'P'

      const subpedidos = this.$store.getters['multiplosPedidos']
      if (subpedidos.length > 0) {
        for (let i = 0; i < subpedidos.length; i++) {
          if (subpedidos[i].fazer_pedido && subpedidos[i].ehValido) {
            subpedidos[i].situacao = 'P'
          }
        }
      }

      await this.onSubmit()
    },

    async gravaPedidos() {
      const data_fim = new Date(
        new Date(this.campanha.data_fim).setHours(
          new Date(this.campanha.data_fim).getHours() + 3,
        ),
      )
      const agora = new Date()
      if (agora > data_fim) {
        this.$toast.warning(
          'Campanha encerrada. Não é possível realizar pedidos! Acione o administrador do sistema.',
        )
        this.show_overlay = false
        window.clearInterval(this.interval_id)
        return
      }

      this.show_overlay = true
      this.setInputs()

      var pedido = this.form
      pedido.situacao = this.pedidoValido === true ? 'P' : 'A'
      const pedidoID = this.$store.getters['pedidoInfo'].pedido_id
      pedido.created_user = parseInt(this.$store.getters['user'].usuario)
      pedido.id = pedidoID ? pedidoID : null
      var produtos = this.produtos
      delete pedido.cam_campanha_nome
      delete pedido.cam_cond_pgto_desc
      delete pedido.valor_minimo
      delete pedido.observacao

      var temQuantidade = false
      for (let i = 0; i < produtos.length; i++) {
        if (produtos[i].quant_solicitada == '') {
          produtos[i].quant_solicitada = null
        }
        if (parseInt(produtos[i].quant_solicitada) > 0) {
          temQuantidade = true
        }
      }

      if (temQuantidade) {
        var http = new service(`${this.table}`)
        await http
          .create({
            pedido: pedido,
            produtos: produtos,
            validaPedidoDuplicado:
              this.campanha.maispedidos == 'S' ? false : true,
          })
          .then((resp) => {
            this.$toast.success('Pedidos(s) Realizado(s) Com Sucesso!')
            this.$emit('onChangeForm', resp.data.response)
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message)
          })

        this.back()
      } else {
        this.$toast.warning(
          'Não há produtos para serem gravados. Por favor, altere a quantidade de ao menos um produto!',
        )
      }

      this.show_overlay = false
      window.clearInterval(this.interval_id)
    },
    async salvaPedidos() {
      const data_fim = new Date(
        new Date(this.campanha.data_fim).setHours(
          new Date(this.campanha.data_fim).getHours() + 3,
        ),
      )
      const agora = new Date()
      if (agora > data_fim) {
        this.$toast.warning(
          'Campanha encerrada. Não é possível realizar pedidos! Acione o administrador do sistema.',
        )
        this.show_overlay = false
        window.clearInterval(this.interval_id)
        return
      }

      this.show_overlay = true
      this.setInputs()

      var pedido = this.form
      pedido.situacao = 'A'
      const pedidoID = this.$store.getters['pedidoInfo'].pedido_id
      pedido.created_user = parseInt(this.$store.getters['user'].usuario)
      pedido.id = pedidoID ? pedidoID : null
      var produtos = this.produtos
      delete pedido.cam_campanha_nome
      delete pedido.cam_cond_pgto_desc
      delete pedido.valor_minimo
      delete pedido.observacao

      var temQuantidade = false
      for (let i = 0; i < produtos.length; i++) {
        if (produtos[i].quant_solicitada == '') {
          produtos[i].quant_solicitada = null
        }
        if (parseInt(produtos[i].quant_solicitada) > 0) {
          temQuantidade = true
        }
      }

      if (temQuantidade) {
        var http = new service(`${this.table}`)
        await http
          .create({ pedido: pedido, produtos: produtos })
          .then((resp) => {
            this.$toast.success('Pedidos(s) Realizado(s) Com Sucesso!')
            this.$emit('onChangeForm', resp.data.response)
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message)
          })

        this.back()
      } else {
        this.$toast.warning(
          'Não há produtos para serem gravados. Por favor, altere a quantidade de ao menos um produto!',
        )
      }

      this.show_overlay = false
      window.clearInterval(this.interval_id)
    },
    async gravaSubPedidos() {
      this.show_overlay = true
      const subpedidos = this.$store.getters['multiplosPedidos']
      if (subpedidos.length > 0) {
        const mensagem = 'Esta farmácia já possui pedido para esta campanha!'
        for (let i = 0; i < subpedidos.length; i++) {
          this.validaFarmaciarRepetida(subpedidos[i])
          if (
            subpedidos[i].mensagem === mensagem &&
            subpedidos[i].fazer_pedido
          ) {
            this.$toast.warning(
              `A farmácia ${subpedidos[i].nomereduzido} já possui um pedido para esta campanha!`,
            )
          } else if (
            subpedidos[i].mensagem !== mensagem &&
            subpedidos[i].fazer_pedido
          ) {
            var produtos = subpedidos[i].produtosPedido
            var temQuantidade = false
            for (let i = 0; i < produtos.length; i++) {
              if (produtos[i].quant_solicitada == '') {
                produtos[i].quant_solicitada = null
              }
              if (parseInt(produtos[i].quant_solicitada) > 0) {
                temQuantidade = true
              }
            }

            if (temQuantidade) {
              var totalPedido = this.calculaValorSubpedido(produtos)
              await this.validaPedidoFilial(subpedidos[i])
              var pedido = {
                cam_campanha_id: this.pedidoPrincipalInfo.cam_campanha_id,
                cam_cond_pgto_id: this.pedidoPrincipalInfo.cam_cond_pgto_id,
                cam_pessoa_id: this.pedidoPrincipalInfo.cam_pessoa_id,
                farmacia_id: subpedidos[i].id,
                total: totalPedido,
                emissao: this.fieldsInput[5].value,
                situacao: subpedidos[i].ehValido === true ? 'P' : 'A',
                created_user: parseInt(this.$store.getters['user'].usuario),
              }

              var http = new service(`${this.table}`)
              await http
                .create({ pedido: pedido, produtos: produtos })
                .then((resp) => {
                  this.$emit('onChangeForm', resp.data.response)
                })
                .catch((e) => {
                  this.$toast.error(e.response.data.message)
                })
            } else {
              this.$toast.warning(
                `Não houveram produtos no pedido da ${subpedidos[i].nomereduzido}. Realize o pedido novamente!`,
              )
            }
          }
        }

        this.$store.commit({
          type: 'setMultiplosPedidos',
          value: [],
        })

        await this.getListaPedidos()
        //this.$toast.success('Pedidos(s) Realizado(s) Com Sucesso!')
      }

      this.show_overlay = false
    },
  },
}
</script>
<style lang="css" scoped>
.status {
  padding: 1.3rem 0;
  border-radius: 5px;
  display: flex;
  justify-content: center;
}
</style>
